import TimeClock from './time-clock'

export default TimeClock